<template>

  <div v-if="news" class="page-wrapper container-custom ">
    <div class="heading">
      <OneNewsPost
          :content="news.content.body"
          :date="news.content.subTitle"
          :image-url="news.content.imageUrl[0]"
          :title="news.content.title"/>
    </div>
    <div class="more-news-wrapper">
      <TitlesDescriptionComponent
          :size="'small'"
          :title="$t('one-news-page-bottom-title')"/>
      <SelectedPostsGridCarousel :newsdata="newsdata"/>
    </div>
  </div>
</template>

<script>


import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";
import SelectedPostsGridCarousel from "@/components/Components/SelectedPostsGridCarousel/SelectedPostsGridCarousel.vue";
import OneNewsPost from "@/components/Components/OneNewsPost/OneNewsPost.vue";

export default {
  name: 'OneNewsView',
  components: {
    OneNewsPost,
    SelectedPostsGridCarousel,
    TitlesDescriptionComponent,


  },

  data() {
    return {
      news: null,
      newsdata: null
    };
  },
  watch: {
    async '$route'() {
      await this.loadNews();
    }
  },
  async mounted() {
    await this.loadNews()
  },
  methods: {
    async loadNews() {
      const id = this.$route.params.id;
      this.news = null;
      const response = await this.$store.dispatch("news/getNews", {limit: 4});
      this.newsdata = response.data;
      this.news = await this.$store.dispatch("news/getNew", {id: id});
    }
  }
};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
}

.heading {
  margin-top: 90px;
  padding: 20px 0px;
}

.more-news-wrapper {
  margin-bottom: 20px;
}

@media screen and (min-width: 768px) {
  .heading {
    margin-top: 120px;
    padding: 20px 0;
  }
  .more-news-wrapper {
    margin-bottom: 50px;
  }

}

@media screen and (min-width: 1700px) {
  .heading {
    margin-top: 120px;
    padding: 20px;
  }
}
</style>